import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import connection from "../../connection";
import general from "../../general";

// @material-ui/icons
// import LockOutline from "@material-ui/icons/LockOutline";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nifInvalid: false,
      passwordInvalid: false,
      modal: null,
      loggingIn: false
    };

    this.password = null;
    this.nif = null;

    this.performLogin = this.performLogin.bind(this);
    this.inputChange = this.inputChange.bind(this);
  }

  inputChange(event) {
    let val = event.target.value;
    let newState = {};
    if (val === null || val.length < 3) {
      newState[event.target.id + "Invalid"] = true;
    } else {
      this[event.target.id] = event.target.value;
      newState[event.target.id + "Invalid"] = false;
    }
    this.setState(newState);
  }

  performLogin() {
    if (this.state.loggingIn) return;
    this.setState({loggingIn: true});
    connection.post("login", {nif: this.nif, password: this.password}, (data) => {
      this.setState({loggingIn: false});
      general.success("Login efectuado com sucesso.", "Sucesso");
      window.App.getLoginState(() => {
        window.App.hist.push("/dashboard");
      });
    }, () => {
      this.setState({loggingIn: false});
    });
  }

  render() {
    const {classes} = this.props;
    let loginDisabled = !(this.password && this.nif) || this.state.loggingIn || this.state.passwordInvalid || this.state.nifInvalid;

    return (
      <div className={classes.container}>
        {this.state.modal}
        <form>
          <Card login>
            <CardHeader
              color="primary">
              <h4>Iniciar Sessão</h4>
              <p>Utilize as mesmas credenciais da loja escutista</p>
            </CardHeader>
            <CardBody>
              <CustomInput
                labelText="NIF"
                id="nif"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon className={classes.inputAdornmentIcon}>
                        person
                      </Icon>
                    </InputAdornment>
                  ),
                  onChange: this.inputChange,
                  onKeyDown: (e) => {
                    if (e.key === "Enter" && !loginDisabled) {
                      this.performLogin();
                    }
                  },
                  error: this.state.nifInvalid
                }}
              />
              <CustomInput
                labelText="Password"
                id="password"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon className={classes.inputAdornmentIcon}>
                        lock_outline
                      </Icon>
                    </InputAdornment>
                  ),
                  onChange: this.inputChange,
                  onKeyDown: (e) => {
                    if (e.key === "Enter" && !loginDisabled) {
                      this.performLogin();
                    }
                  },
                  error: this.state.passwordInvalid,
                  type: "password"
                }}
              />
            </CardBody>
            <CardFooter className={classes.justifyContentCenter + " " + classes.displayBlock}>
              <Button fullWidth color="romano" size="lg" block onClick={this.performLogin}
                      disabled={loginDisabled}>
                {this.state.loggingIn ? "Aguarde..." : "Continuar"}
              </Button>
              <a href={"https://dmf.escutismo.pt/area-pessoal/"} target={"_blank"}>
                <Button fullWidth color="romano" simple size="lg" block>
                  Registar nova conta
                </Button>
              </a>
            </CardFooter>
          </Card>
        </form>
        <a className={classes.forgotPassword}
           href={"https://dmf.escutismo.pt/area-pessoal/recuperar-senha/"} target={"_blank"}>Recuperar password</a>
      </div>

    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(LoginPage);
